import Container from "@/components/ui/container"
import { H1, H2 } from "@/components/ui/headings"
import Panel from "@/components/ui/panel"
import LoadingScreen from "@/novus/components/loading-screen"
import { useCurrentOrganization } from "@/novus/hooks/useCurrentOrganization"
import { MainLayout } from "@/novus/layouts/MainLayout"
import React from "react"
import { MagicCodeForm } from "./components/MagicCodeForm"
import { WorkEmailForm } from "./components/WorkEmailForm"

type OrgOnboardingStep = "submitWorkEmail" | "enterMagicCode"

export const OrgOnboardingScreen = () => {
  const { organization } = useCurrentOrganization()
  const [step, setStep] = React.useState<OrgOnboardingStep>("submitWorkEmail")

  if (!organization) {
    return <LoadingScreen />
  }

  return (
    <MainLayout>
      <Container>
        <div className="text-center">
          <H1>Welcome to Hadley</H1>
          <H2>
            {organization.name} has invited you to join their organization.
          </H2>
        </div>

        <div className="mt-20">
          <H1>Verify your work email address</H1>
        </div>
        <Panel>
          {step === "submitWorkEmail" ? (
            <WorkEmailForm onComplete={() => setStep("enterMagicCode")} />
          ) : step === "enterMagicCode" ? (
            <MagicCodeForm onBackClick={() => setStep("submitWorkEmail")} />
          ) : null}
        </Panel>
      </Container>
    </MainLayout>
  )
}
